import React, { useEffect, useRef } from 'react';
import {
  Body,
  FormCadastro,
  Input,
  InputNumber,
  PageHeader,
  Select,
  Spin,
  Switch,
  View,
  Field,
  GroupField,
  SubmitButton,
} from '@components';
import { getConfiguracao, postConfiguracao, putConfiguracao, reset } from '@ducks/conectoresConfiguracoes';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import App from '@app';
import { getClientes } from '@sdk/Clientes';

export default function Detalhes() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const conectorIdentifyInput = useRef(null);
  const [form] = FormCadastro.useForm();
  const edicao = id !== '-1';
  let clientes = [];

  const configuracao = useSelector(({ conectoresConfiguracoes }) => conectoresConfiguracoes.get('configuracao'));
  const loadingConfiguracao = useSelector(({ conectoresConfiguracoes }) => conectoresConfiguracoes.get('loadingConfiguracao'));
  const successConfiguracao = useSelector(({ conectoresConfiguracoes }) => conectoresConfiguracoes.get('successConfiguracao'));
  const successPut = useSelector(({ conectoresConfiguracoes }) => conectoresConfiguracoes.get('successPutConfiguracao'));
  const successPost = useSelector(({ conectoresConfiguracoes }) => conectoresConfiguracoes.get('successPostConfiguracao'));

  const handleReset = () => dispatch(reset());

  useEffect(() => {
    form.setFieldsValue({ ativo: true, url: 'https://teammove.app' });
    const el = document.getElementById('idCliente');
    el.disabled = false;
    el.focus();
  }, []);

  useEffect(() => {
    if (edicao) {
      dispatch(getConfiguracao(id));
    }
  }, []);

  useEffect(() => {
    if (successPut || successPost) {
      handleReset();
      history.goBack();
    }
  }, [successPut, successPost]);

  useEffect(() => {
    if (configuracao && edicao) {
      form.setFieldsValue(configuracao);
    }
  }, [successConfiguracao]);

  function handleSubmit(data) {
    if (edicao) {
      data['id'] = configuracao.id;
      dispatch(putConfiguracao(data));
    } else {
      dispatch(postConfiguracao(data));
    }
  }

  async function setIdentify(value) {
    if (!clientes.length) {
      clientes = await getClientes();
    }

    const identify = clientes.find((cliente) => cliente.value === value).key;
    form.setFieldsValue({ conectorIdentify: identify });

    if (conectorIdentifyInput && conectorIdentifyInput.current && conectorIdentifyInput.current.input) {
      conectorIdentifyInput.current.input.focus();
    }
  }

  return (
    <App>
      <Body>
        <PageHeader title="Conector" onBack={() => history.goBack()}>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            {loadingConfiguracao ? (
              <Spin />
            ) : (
              <View>
                <GroupField>
                  <Field label="Cliente" name="idCliente" rules={[{ required: true, message: 'Informe o cliente' }]}>
                    {edicao ? (
                      <Select form={form} name="idCliente" action={() => getClientes()} disabled />
                    ) : (
                      <Select
                        form={form}
                        name="idCliente"
                        action={() => getClientes()}
                        onChange={(value) => setIdentify(value)}
                        placeholder="Selecione um cliente"
                        autoFocus
                      />
                    )}
                  </Field>

                  <Field label="Identify" name="conectorIdentify" rules={[{ required: true, message: 'Informe o identify' }]}>
                    {edicao ? <Input disabled /> : <Input ref={conectorIdentifyInput} />}
                  </Field>
                </GroupField>
                <GroupField>
                  <Field label="URL" name="url" rules={[{ required: true, message: 'Informe a URL' }]}>
                    {edicao ? <Input autoFocus /> : <Input />}
                  </Field>
                </GroupField>
                <GroupField>
                  <Field
                    label="Intervalo de Atualização (segundos)"
                    name="periodoAtualizacaoComando"
                    rules={[{ required: true, message: 'Informe o intervalo' }]}
                  >
                    <InputNumber />
                  </Field>
                  <Field
                    label="Porta Mini Server"
                    name="portaMiniServer"
                    rules={[
                      {
                        required: true,
                        message: 'Informe a porta do mini servidor',
                      },
                    ]}
                  >
                    <InputNumber />
                  </Field>
                  <Field label="Ativo" name="ativo" valuePropName="checked" rules={[{ required: true, message: 'Informe o status' }]}>
                    <Switch defaultChecked />
                  </Field>
                </GroupField>
                <SubmitButton type="success" htmlType="submit" block>
                  Salvar
                </SubmitButton>
              </View>
            )}
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
